if (!customElements.get('product-tile')) {
  class ProductTile extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (!this.isConnected) return;

      const radioInputs = this.querySelectorAll('input[type="radio"][name^="Color-"]');
      const colorGroups = this.querySelectorAll('[data-color]');
      const variantInput = this.querySelector('[data-main-select]');
      const urlAnchor = this.querySelector('[data-product-url]');

      if (!radioInputs.length || !colorGroups.length || !variantInput || !urlAnchor) return;

      radioInputs.forEach((radio) => {
        radio.addEventListener('change', () => {
          if (!radio.checked) return;

          const selectedColor = radio.value.trim().toLowerCase();

          // aria-current
          radioInputs.forEach((r) => r.removeAttribute('aria-current'));
          radio.setAttribute('aria-current', 'true');

          // Image groups
          colorGroups.forEach((group) => {
            const groupColor = group.getAttribute('data-color')?.trim().toLowerCase();
            group.style.display = groupColor === selectedColor ? '' : 'none';
          });

          //URL and Form ID
          const variantId = radio.dataset.activeVariant;
          variantInput.setAttribute('value', variantId);      
          const baseUrl = urlAnchor.getAttribute('href')?.split('?')[0] || '';
          urlAnchor.setAttribute('href', `${baseUrl}?variant=${variantId}`);
        });
      });
    }

  }

  customElements.define('product-tile', ProductTile);
}
